import React from "react";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import withDefaultParams from "Services/withDefaultParams";
import { PhoneButton, WaitCallPhoneButton } from "ComponentsUI/Navigation";
import { withPhone } from "HOC/WithPhone";
import { EVENT_CATEGORY_CLICK_BUTTON } from "Constants/metriks/GoogleCategorys";
import { EVENT_CLICK_PHONE_MAIN } from "Constants/metriks/GoogleActions";
import { YANDEX_TARGETS } from "Constants/metriks/yandex-targets";
import Metrika from "Services/Metrika";
import { isMobilePage } from "Utils/routeCheck";

const mobileURLs = [
    "/:regionUrl?/operatory/:operator/sim-karty/:tagCode?",
    "/:regionUrl?/sim-karty/:tagCode?",
];

@withRouter
@withDefaultParams
@withPhone
@inject("ApplicationModel")
@observer
export default class PhoneContainerHeader extends React.Component {
    static defaultProps = {
        onClick: () => {},
    };

    onClickHandler() {
        //let siteCode = this.props.ApplicationModel.siteCode;
        Metrika.getInstance().google.sendEvent(
            EVENT_CATEGORY_CLICK_BUTTON,
            EVENT_CLICK_PHONE_MAIN
        );
        Metrika.getInstance().yandex.sendEvent(
            YANDEX_TARGETS.CLICK_COMPASSION_PHONE_BUTTON_REAL,
            []
        );
    }
    render() {
        let { siteRegionPhones, phone404 } = this.props;
        let text = this.props.ApplicationModel.text;
        let insinePhone = "";
        let numbers = "";
        let code = "";
        let formatPhone = "";

        if (phone404) {
            insinePhone = "+78001008406";
            formatPhone = "+7 (800) 100-84-06";
            return (
                <PhoneButton
                    onClickHandler={() => this.onClickHandler()}
                    text={text}
                    fixedTheme={this.props.fixedTheme}
                    passiveTheme={this.props.passiveTheme}
                    phone={formatPhone}
                    insinePhone={insinePhone}
                />
            );
        }

        if (!this.props.siteRegionPhones) {
            return null;
        }
        let xs = this.props.ApplicationModel.windowSizeModel.windowSizes.xs;

        if (isMobilePage(this.props?.match?.path)) {
            if (
                !this.props.siteRegionPhones?.operators?.show_on_site ||
                this.props.siteRegionPhones?.operators?.phone_view === "hide"
            ) {
                return null;
            }
            if (!this.props.siteRegionPhones?.operators?.phone) {
                return null;
            }
        } else {
            if (!this.props.siteRegionPhones.show_on_site && xs) {
                return (
                    <WaitCallPhoneButton
                        store={this.props.ApplicationModel}
                        onClickHandler={() => this.onClickHandler()}
                        text={text}
                        fixedTheme={this.props.fixedTheme}
                        passiveTheme={this.props.passiveTheme}
                    />
                );
            }
            if (!this.props.siteRegionPhones.phone) {
                return null;
            }
        }

        code = siteRegionPhones.code;
        numbers = siteRegionPhones.phone;
        insinePhone = `+7${
            siteRegionPhones.code
        }${siteRegionPhones.phone.replace(/\-/g, "")}`;
        formatPhone = `+7 (${code}) ${numbers}`;

        if (
            isMobilePage(this.props?.match?.path) &&
            siteRegionPhones?.operators?.phone
        ) {
            code = siteRegionPhones?.operators?.code;
            numbers = siteRegionPhones?.operators?.phone;
            insinePhone = `+7${
                siteRegionPhones?.operators?.code
            }${siteRegionPhones?.operators?.phone.replace(/\-/g, "")}`;
            formatPhone = `+7 (${code}) ${numbers}`;
        }

        //Не показывать кнопку телефона на мобильных страницах
        if (mobileURLs.includes(this.props?.match?.path)) {
            return null;
        }

        return (
            <PhoneButton
                onClickHandler={() => this.onClickHandler()}
                text={text}
                fixedTheme={this.props.fixedTheme}
                passiveTheme={this.props.passiveTheme}
                phone={formatPhone}
                insinePhone={insinePhone}
            />
        );
    }
}
